import React, { useState, useEffect } from "react";
import LineItemsForm from "./LineItemsForm";
import { NameCard } from "./NameCard";
import actionPlanFeedbackService from "../../../apis/Business/ActionPlanFeedbackApi";
import "./index.css";

export const Feedback = ({ effortId }) => {
  const [feedback, setFeedback] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (effortId) {
      fetchFeedback();
    }
  }, [effortId]);

  const fetchFeedback = async () => {
    try {
      const data = await actionPlanFeedbackService.getFeedback(effortId);
      const formattedData = data.map((item) => ({
        id: String(item.id),
        title: item.title,
        type: item.description,
      }));
      setFeedback(formattedData);
    } catch (error) {
      console.error("Error fetching feedback:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (items) => {
    try {
      const currentIds = new Set(feedback.map((i) => i.id));
      const newIds = new Set(items.map((i) => i.id));

      // Items to create
      const itemsToCreate = items.filter((item) => !currentIds.has(item.id));

      // Items to update
      const itemsToUpdate = items.filter((item) => currentIds.has(item.id));

      // Items to delete
      const itemsToDelete = feedback.filter((item) => !newIds.has(item.id));

      // Process creations
      for (const item of itemsToCreate) {
        await actionPlanFeedbackService.createFeedback(effortId, {
          title: item.title,
          description: item.type,
        });
      }

      // Process updates
      for (const item of itemsToUpdate) {
        await actionPlanFeedbackService.updateFeedback(effortId, item.id, {
          title: item.title,
          description: item.type,
        });
      }

      // Process deletions
      for (const item of itemsToDelete) {
        await actionPlanFeedbackService.deleteFeedback(effortId, item.id);
      }

      // Refresh the list
      await fetchFeedback();
    } catch (error) {
      console.error("Error updating feedback:", error);
    }
  };

  return (
    <div className="feedback-section">
      <NameCard
        deptName="Feedback"
        isBottom={false}
        className="other-effort-container"
      />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
        className="action-plans-parent-bubble"
      >
        <p
          style={{
            color: "#1B3764",
            fontSize: "14px",
            maxWidth: "700px",
          }}
        >
          Measure, assess, prioritize, & adjust. In the Feedback loop, any
          learnings are feedback to the administration. Please include here:
          what are/where the challenges, what did we learn, any roadblocks, good
          take aways, etc.
        </p>
        <LineItemsForm
          initialData={feedback}
          onSubmit={handleSubmit}
          showAmountFields={false}
          mode="feedback"
        />
      </div>
    </div>
  );
};

export default Feedback;
